import { render } from "./FamilyOffice.vue?vue&type=template&id=5accbd44&scoped=true"
import script from "./FamilyOffice.vue?vue&type=script&lang=js"
export * from "./FamilyOffice.vue?vue&type=script&lang=js"

import "./FamilyOffice.vue?vue&type=style&index=0&id=5accbd44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5accbd44"]])

export default __exports__